<template>
<span>
  <v-text-field
    v-model="model"
    :label="label"
    type="number"
    :disabled="disabled"
    @input="onInput"
    color="teal lighten-2"
    :readonly="readonly" />

</span>
</template>
<script>
export default {
  name: 'number-input',
  data () {
    return {
      model: this.value
    }
  },
  methods: {
    onInput () {
      this.$emit('input', this.model)
    }
  },
  props: {
    value: {},
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style>
    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance:textfield;
    }
</style>
